import { render } from "./ToastStack.vue?vue&type=template&id=64d4fbff&scoped=true"
import script from "./ToastStack.vue?vue&type=script&lang=js"
export * from "./ToastStack.vue?vue&type=script&lang=js"

import "./ToastStack.vue?vue&type=style&index=0&id=64d4fbff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d4fbff"]])

export default __exports__